import { jsx as _jsx } from "react/jsx-runtime";
const CameraOffIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M3.27 2L2 3.27L4.73 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H16C16.2 18 16.39 17.92 16.54 17.82L19.73 21L21 19.73M21 6.5L17 10.5V7C17 6.73478 16.8946 6.48043 16.7071 6.29289C16.5196 6.10536 16.2652 6 16 6H9.82L21 17.18V6.5Z", fill: props.color }) })));
};
CameraOffIcon.defaultProps = {
    color: 'white',
};
export default CameraOffIcon;
